import React from 'react';
import PageBanner from '../layout/PageBanner';
import SectionHeading from '../ui/SectionHeading';
import { recipes } from '../../data/recipes';
import BetaLink from '../../beta/BetaLink';

const RecipesPage = () => {
  return (
    <div>
      <PageBanner
        title="Mirage Recipes"
        breadcrumbs={[{ label: 'MIRAGE RECIPES' }]}
      />

      <section className="py-16 px-6">
        <div className="max-w-5xl mx-auto">
          <SectionHeading
            title="Mirage Recipes"
            subtitle="Click a recipe to view full preparation details"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {recipes.map((recipe) => (
              <BetaLink
                key={recipe.id}
                to={recipe.path}
                className="group block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={recipe.cardImage}
                    alt={recipe.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-serif font-bold text-gray-900">
                    {recipe.title}
                  </h3>
                  <span className="inline-block mt-3 text-primary-red font-medium">
                    View Recipe →
                  </span>
                </div>
              </BetaLink>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default RecipesPage;
